import * as CONST from '../const/shared'
import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import { currentSite, i18n } from '../extend'

Vue.use(Vuetify)

const theme = {
  transitionsPrimary: '#002D72',
  notification: '#D73965',
  primaryAccent: '#0041c3',
  primaryBtn: '#0041c3',
  primary: '#0041c3',
  primaryCalendar: '#0041c3',
  text: {
    base: '#454C5E',
    lighten1: '#7E7E7E',
    lighten2: '#C4C4C4'
  },
  secondary: {
    base: '#454C5E',
    lighten1: '#E4E8EC',
    lighten2: '#F2F4F6'
  },
  lightGrey: '#E8E8E8',
  cancelled: '#D73965'
}

// service colors
for (const serviceType of CONST.serviceTypeValues.filter(s => Boolean(s.color))) {
  theme[serviceType.value] = serviceType.color
}


if (currentSite() === CONST.sites.galileo) {
  theme.primary = '#D31145'
  theme.primaryAccent = '#059D6D'
  theme.primaryBtn = '#D31145'
  theme.primaryCalendar = '#D31145'

  theme.secondary = {
    base: '#2A2C32',
    lighten1: '#F2F4F6',
    lighten2: '#F2F4F6'
  }
}

if ([CONST.sites.nikon, CONST.sites['nikon-it']].includes(currentSite())) {
  theme.primary = '#FFE600'
  theme.primaryAccent = '#FFE600'
  theme.primaryBtn = '#FFE600'
  theme.primaryCalendar = '#3B404B'

  theme.secondary = {
    base: '#000',
    lighten1: '#F2F4F6',
    lighten2: '#F2F4F6'
  }
}

export default new Vuetify({
  lang: {
    t: (key, ...params) => {
      console.log(key, params)
      return i18n.t(key, params)
    }
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: theme
    }
  }
})
